<template>
	<v-sheet elevation="0">
		<div v-if="printedMatter.document_type != 'customer_order'"></div>
		<template v-else>
			<DeliverySlip
				v-if="printedMatter.name == '納品書'"
				:printedMatter="printedMatter"
				:printed_matter_records="printedMatterRecords"
				:editable="false"
				@handle-print="handlePrint"
			/>
			<InvoiceSlip
				v-if="printedMatter.name == '請求書'"
				:printedMatter="printedMatter"
				:printed_matter_records="printedMatterRecords"
				:editable="false"
				@handle-print="handlePrint"
			/>
			<DispatchSlip
				v-if="printedMatter.name == '送品案内書'"
				:printedMatter="printedMatter"
				:printed_matter_records="printedMatterRecords"
				:editable="false"
				@handle-print="handlePrint"
			/>
		</template>
	</v-sheet>
</template>

<script>
import axios from "axios"
import Qs from "qs";
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"

export default {
	components: {
		DeliverySlip: () => import("../printed_matter/customer_orders/DeliverySlip.vue"),
		InvoiceSlip: () => import("../printed_matter/customer_orders/InvoiceSlip.vue"),
		DispatchSlip: () => import("../printed_matter/customer_orders/DispatchSlip.vue"),
	},
	data() {
		return {
			printed_matter_id: this.$route.params.printed_matter_id,
			printedMatter: { id: null, document_type: null, name: null },
			printedMatterRecords: null,
			common,
		}
	},
	mounted() {
		this.fetchPrintedMatterRecord()
	},
	methods: {
		fetchPrintedMatterRecord() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/printed_matters/${this.printed_matter_id}/printed_matter_records/`
			const params = {ids:this.$route.query.ids}
			console.log(params)
			axios
				.get(url, { params, headers })
				.then((res) => {
					this.printedMatterRecords = res.data.printed_matter_records
					this.printedMatter = res.data.printed_matter
					if (this.printedMatter.document_type == "customer_order") {
						return
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		handlePrint() {
			const area = document.getElementById("sheets")
			document.body.innerHTML = area.innerHTML
			window.print()
			this.$router.go({ path: this.$router.currentRoute.path, force: true })
		},
	},
}
</script>
